import { render, staticRenderFns } from "./InstructorsReport.vue?vue&type=template&id=c2b56368&"
import script from "./InstructorsReport.vue?vue&type=script&lang=js&"
export * from "./InstructorsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2b56368')) {
      api.createRecord('c2b56368', component.options)
    } else {
      api.reload('c2b56368', component.options)
    }
    module.hot.accept("./InstructorsReport.vue?vue&type=template&id=c2b56368&", function () {
      api.rerender('c2b56368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/reports/InstructorsReport.vue"
export default component.exports